import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useTheme } from "../../utils/ThemeContext";
import DEATH_API from "../../apis/death.api";

const RecurringBillsTable = () => {
  const { theme } = useTheme();
  const [loading, setLoading] = useState(false);
  const [recurringData, setRecurringData] = useState([]);

  const getRecurringTransactionsData = async () => {
    try {
      setLoading(true);
      const response = await DEATH_API.getRecurringTransaction();
      if (response && response.data) {
        const allAccount = response.data.filter((item) => {
          return item.hidden !== true;
        });
        setRecurringData(allAccount);
      }
    } catch (error) {
      console.error("Error fetching recurring transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRecurringTransactionsData();
  }, []);

  return (
    <div style={{position:"relative"}}>
        <div
          style={{
            backgroundColor: theme === "dark" ? "#232323" : "white",
          }}
        >
          <div>
            <h3
              style={{
                color: theme === "light" ? "#232323" : "white",
              }}
            >
              Recurring Transactions
            </h3>
          </div>
          <div
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "white",
            }}
            className="main-dashboad-table-container"
          >
            <div className="table-wrapper">
              <table
                className={
                  theme == "dark" ? "custom-table-dark" : "custom-table"
                }
              >
                <thead
                  style={{
                    backgroundColor: theme === "dark" ? "#232323" : "white",
                  }}
                >
                  <tr
                    style={{
                      fontWeight: "700",
                    }}
                  >
                    <th
                      style={{
                        color: theme === "dark" ? "#ffffff" : "#232323",
                      }}
                    >
                      Bill
                    </th>
                    <th
                      style={{
                        color: theme === "dark" ? "#ffffff" : "#232323",
                      }}
                    >
                      Bank
                    </th>
                    <th
                      style={{
                        color: theme === "dark" ? "#ffffff" : "#232323",
                      }}
                    >
                      Amount
                    </th>
                    <th
                      style={{
                        color: theme === "dark" ? "#ffffff" : "#232323",
                      }}
                    >
                      Due
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    backgroundColor: theme === "dark" ? "#232323" : "white",
                  }}
                >
                  {recurringData && recurringData.length > 0 ? (
                    recurringData.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        <td
                          style={{
                            color: theme === "light" ? "#232323" : "white",
                          }}
                        >
                          {row.itemName || "N/A"}
                        </td>
                        <td
                          style={{
                            color: theme === "light" ? "#232323" : "white",
                          }}
                        >
                          {row.bankName || "N/A"}
                        </td>
                        <td
                          style={{
                            color: theme === "light" ? "#232323" : "white",
                          }}
                        >
                          ${row.amount ? row.amount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "N/A"}
                        </td>
                        <td
                          style={{
                            color: theme === "light" ? "#232323" : "white",
                          }}
                        >
                          {row.dueDate
                            ? new Date(row.dueDate).toLocaleDateString(
                                "en-US",
                                {
                                  month: "short",
                                  day: "2-digit",
                                  year: "numeric",
                                }
                              )
                            : "N/A"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                          textAlign: "center",
                        }}
                      >
                        {loading ? "Loading..." : "No data available"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      {loading ? (
        <div style={{ marginTop: "12px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "64px", borderRadius: "12px", border: "1px solid rgba(74, 98, 255, 0.35)", background: "linear-gradient(135deg, rgba(42, 61, 163, 0.16), rgba(42, 61, 163, 0.06))", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14)" }}>
          <Spin size="large" />
        </div>
      ) : null}
    </div>
  );
};

export default RecurringBillsTable;
